import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsBpiConstants {
    static STEP_TITLE = "Details";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static DESCRIPTION_LABEL = "Description";
    static BPAMS_REFERENCE_NUMBER_LABEL = "Building plan reference number?";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME = "bpamsReferenceNumber";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "referenceNumber";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        bpamsReferenceNumber: {
            required: `Building plans reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        referenceNumber: {
            required: `Reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
